import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createViewCopyDisable: true,
  createViewCopy: false,
  /** User changed the Word auto-generate toggle for this document class/format session. Cleared when class changes. */
  viewCopyAutogenerateUserAdjusted: false,
  viewCopyFiles: [],
  uploadViewCopyCount: 0,
};

const checkInFormSlice = createSlice({
  name: "checkin/checkInForm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase("ON_VIEWCOPY_AUTOGENERATE_USER_ADJUSTED", (state, action) => {
        state.viewCopyAutogenerateUserAdjusted = !!action.payload;
      })
      .addCase("ON_CREATE_VIEWCOPY_CHANGED", (state, action) => {
        state.createViewCopy = action.payload;
      })
      .addCase("ON_CREATE_VIEWCOPY_ENABLE_CHANGED", (state, action) => {
        state.createViewCopyDisable = action.payload;
      })
      .addCase("ON_VIEWCOPYUPLOAD_CHANGE", (state, action) => {
        state.viewCopyFiles = action.payload;
      })
      .addCase("ON_UPLOADEDVIEWCOPY_COUNT_CHANGED", (state, action) => {
        state.uploadViewCopyCount = action.payload;
      });
  },
});

export default checkInFormSlice.reducer;
